import axios from '../config/axios';

export function apiGetActivity(params) {
  return axios.get('activities', { params });
}
